import axios from "axios";
import env from "../../constants/apiConst";
import { withLoading } from "utils/withLoading";

export const __EditCreateForm = async (endpoint, token, data) => {
  return withLoading(async () => {
  const options = {
    method: "POST",
    headers: {
      Authorization: token ? `Bearer ${token}` : "",
      "Content-Type": "multipart/form-data"
    },
    data: data || ""
  };

  const res = await axios(`${endpoint}`, options);
  return res;
  });
};

export const __CreateThirdParties = async (endpoint, token, body) => {
  return withLoading(async () => {
  const options = {
    method: "POST",
    headers: {
      Authorization: token ? `Bearer ${token}` : "",
      "Content-Type": "application/json"
    },
    data: JSON.stringify(body)
  };

  const res = await axios(`${endpoint}`, options);

  return res;
  });
};

export const __EditCreateItem = async (endpoint, token, body) => {
  return withLoading(async () => {
  const options = {
    method: "POST",
    headers: {
      Authorization: token ? `Bearer ${token}` : "",
      "Content-Type": "multipart/form-data"
    },
    data: body || ""
  };

  const res = await axios(`${endpoint}`, options);
  return res;
  });
};

export const __Get_Forms_Entry = async (token, page, body) => {
  return withLoading(async () => {
  const options = {
    method: "POST",
    headers: {
      Authorization: token ? `Bearer ${token}` : ""
    },
    data: body || ""
  };

  const res = await axios(`${env.FORMS_ENTRY_GET}?page=${page || 1}`, options);
  return res;
  });
};

export const __Get_Forms_Exit = async (token, page) => {
  return withLoading(async () => {
  const options = {
    method: "POST",
    headers: {
      Authorization: token ? `Bearer ${token}` : ""
    }
    // data: body ? body : "",
  };

  const res = await axios(`${env.FORMS_EXIT_GET}?page=${page || 1}`, options);
  return res;
  });
};

export const __ShowItems = async (token, id, endpoint) => {
  return withLoading(async () => {
  const options = {
    method: "GET",
    headers: {
      Authorization: token ? `Bearer ${token}` : ""
    }
  };

  const res = await axios(`${endpoint}/${id}`, options);
  return res;
  });
};

export const __GetItems = async (token, body, page, endpoint) => {
  return withLoading(async () => {
  const options = {
    method: "POST",
    headers: {
      Authorization: token ? `Bearer ${token}` : ""
    },
    data: body || ""
  };

  const res = await axios(`${endpoint}?page=${page || 1}`, options);
  return res;
  });
};

export const __DeleteConfig = async (endpoint, token, id) => {
  return withLoading(async () => {  
  const options = {
    method: "GET",
    headers: {
      Authorization: token ? `Bearer ${token}` : ""
    }
  };

  const res = await axios(`${endpoint}/${id}`, options);
  return res;
  });
};

export const __CopyForms = async (endpoint, token, id) => {
  return withLoading(async () => {
    const options = {
      method: "GET",
      headers: {
        Authorization: token ? `Bearer ${token}` : ""
      }
    };

    const res = await axios(`${endpoint}/${id}`, options);
    return res;
  });
};

export const __ChangeStatus = async (endpoint, token, body) => {
  return withLoading(async () => {
  const options = {
    method: "POST",
    headers: {
      Authorization: token ? `Bearer ${token}` : "",
      "Content-Type": "application/json"
    },
    data: body || ""
  };

  const res = await axios(`${endpoint}`, options);
  return res;
  });
};

export const __SearchFormularios = async (endpoint, token, body, page) => {
  return withLoading(async () => {
  const options = {
    method: "POST",
    headers: {
      Authorization: token ? `Bearer ${token}` : "",
      "Content-Type": "multipart/form-data"
    },
    data: body || ""
  };

  const res = await axios(`${endpoint}?page=${page || 1}`, options);
  return res;
  });
};

export const __ObtenerQrForm = async (endpoint, token, body) => {
  return withLoading(async () => {
  const options = {
    method: "POST",
    headers: {
      Authorization: token ? `Bearer ${token}` : "",
      "Content-Type": "application/json"
    },
    data: body || ""
  };

  const res = await axios(`${endpoint}`, options);
  return res;
  });
};
